<template>
  <div class="modal-wrap">
    <div class="modal-content">
      <div class="modal-title">{{ modalTextData.title }}</div>
      <div class="modal-desc">{{ modalTextData.desc }}</div>
      <div class="modal-btn" @click="close">{{ modalTextData.btn }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalTextData: {
      type: Object,
    },
  },
  computed: {},
  methods: {
    close() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  position: fixed;
  z-index: 9998;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 448px;
    background: var(--settings-bg);
    border-radius: 20px;
    box-shadow: 0px 64px 64px -48px rgba(31, 47, 70, 0.12);
    padding: 24px 32px 32px;
    .modal-title {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      color: var(--keypal-popover-title-color);
    }
    .modal-desc {
      margin-top: 8px;
      text-align: center;
      font-size: 14px;
      color: var(--details-overview-label-color);
    }
    .modal-btn {
      margin-top: 40px;
      background: #2980fe;
      border-radius: 90px;
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      color: #fcfcfd;
      padding: 16px 0;
    }
  }
}

@media screen and (max-width: 767px) {
  .modal-wrap {
    .modal-content {
      width: 80%;
      border-radius: 12px;
      padding: 28px 20px;
      .modal-title {
        font-size: 18px;
      }
      .modal-desc {
        font-size: 14px;
        font-weight: 400;
      }
      .modal-btn {
        margin-top: 32px;
        font-size: 15px;
        padding: 13px 0;
      }
    }
  }
}
</style>
